module.exports = __webpack_public_path__ + "img/bandera_valencia.84e339fa.svg";